/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useContext } from 'react';
import { AppContext } from 'Context';
import cn from 'classnames';
import { Tooltip } from '@mui/material';
import { ReactComponent as CreatePlaylist } from 'Assets/create-playlist.svg';
import styles from './index.module.css';

const CreatePlaylistPage = () => {
  const { langText, setShowAddPlaylistModal } = useContext(AppContext);
  const layoutText = langText?.layout;

  return (
    <div className={cn({ [styles.buttonWithText]: true, [styles.placeEnd]: window.screen.width <= 1350 })}>
      <span className={styles.createPlayListTitle}>{'Playlist' || layoutText?.createPlaylist}</span>
      <Tooltip title={layoutText?.createPlaylist || 'Create Playlist'} aria-label="Create Playlist" disableHoverListener={!(window.screen.width <= 1350)}>
        <CreatePlaylist onClick={() => { setShowAddPlaylistModal(true); }} className={styles.playlistMe} />
      </Tooltip>
    </div>
  );
};

export default CreatePlaylistPage;
